import { DayOfWeek } from '@umss/shared/data-access';

export const mockAvailability = [
  {
    id: 5,
    dayOfWeek: DayOfWeek.Monday,
    dayOfWeekDisplay: 'Monday',
    startTime: '00:50:00',
    endTime: '11:27:00',
    isActive: true
  }
];
